import BaseModel from './BaseModel'
import { DefaultRate } from './DefaultRate'
import LocationProduct from './LocationProduct'
import Venue from './Venue'
import VenueTier from './VenueTier'

export class VenueLocationProduct extends BaseModel {

  static entity = 'venue_location_products'
  static primaryKey = 'ID'

  declare ID: number
  declare venueID: number
  declare locationProductID: number
  declare defaultPrice: number
  declare defaultInventory: number
  declare live: boolean
  declare entryHoursBeforeEvent: number | null
  declare exitHoursAfterEvent: number | null
  declare defaultRateID: number
  declare venue: Venue
  declare locationProduct: LocationProduct
  declare venueTiers: VenueTier[]

  static fields() {

    return {

      // fields
      ID: this.number(null),
      venueID: this.number(null),
      locationProductID: this.number(null), // virtual column
      defaultPrice: this.number(null),
      defaultInventory: this.number(null),
      live: this.boolean(false),
      entryHoursBeforeEvent: this.number(null).nullable(),
      exitHoursAfterEvent: this.number(null).nullable(),
      defaultRateID: this.number(null), // virtual column

      // relationships
      defaultRate: this.belongsTo(DefaultRate, 'defaultRateID'),
      venue: this.belongsTo(Venue, 'venueID'),
      locationProduct: this.belongsTo(LocationProduct, 'locationProductID'),
      venueTiers: this.hasMany(VenueTier, 'venueLocationProductID'),
      
    }

  }

  /**
   * API methods
   */

  static saveExisting(locationId: number, vlpId: number, payload: UpdateVlpRequest) {

    return this.api().patch(`/venues/location/${locationId}/vlp/${vlpId}`, payload, {
      dataTransformer: ({ data }) => {

        // If any venueTiers were deleted, remove them from the Vuex store

        const oldVenueTierIDs = VenueTier.query().where('venueLocationProductID', vlpId).get().map((vt: VenueTier) => vt.ID)
        const venueTierIDsToKeep = data.venueTiers.map((vt: any) => vt.ID)

        oldVenueTierIDs.forEach(oldVenueTierID => {
          if (!venueTierIDsToKeep.includes(oldVenueTierID)) {
            VenueTier.delete(oldVenueTierID)
          }
        })

        return data

      }
    })/*.catch((error) => {
      throw error.response.data
    }) */

  }

}

export type UpdateVlpRequestVenueTier = {
  tierID: null | number
  tierPrice: number // int, in cents
  tierInventoryPercentage: number
}

export type UpdateVlpRequest = {
  // any of the properties below can be omitted to leave that column unchanged
  // (this is different than setting the column to null)
  defaultInventory?: number
  live?: boolean
  entryHoursBeforeEvent?: null | number
  exitHoursAfterEvent?: null | number
  venueTiers?: UpdateVlpRequestVenueTier[]
}
